export enum ChartType {
    Small = "small",
    Default = "default",
}
